/* eslint-disable arrow-body-style */
import * as React from "react";
import {Component} from "react";

import {observer} from "mobx-react";

import {Input} from "semantic-ui-react";

import {Auftragsverwaltung} from "../../stores/auftragsverwaltung-mobx";

import {Project} from "../../models/project";
import {InputOnChangeData} from "semantic-ui-react/dist/commonjs/elements/Input/Input";


export interface ContractorSearchProps {
    auftragsverwaltung: Auftragsverwaltung;
    projects?: Project[] | null;
}

@observer
export class ContractorSearch extends Component<ContractorSearchProps, any> {
    autorunDisposers: any[] = [];

    constructor(props: ContractorSearchProps) {
        super(props);
        this.state = {
            loading: false,
            value: props.auftragsverwaltung.ContractorStore.searchTerm || ""
        };

        this.handleSearchChange = this.handleSearchChange.bind(this);
    }

    componentDidMount(): void {}

    componentWillUnmount(): void {}

    render(): React.ReactElement | null {
        const { value} = this.state;
        // const {projects} = this.props;

        // const results = projects?.map((p) => {
        //     return { title: p.name, description: p.reason };
        // });

        return (
            <Input
                fluid
                placeholder="Organisationsname, Kontakt..."
                onChange={this.handleSearchChange}
                value={value}
                size="mini"
                icon="search"
            />
            // <Search
            //     loading={loading}
            //     placeholder="Organisationsname, Kontakt..."
            //     // onResultSelect={(e, data) =>
            //     //     this.setState({
            //     //         value: data.result.title
            //     //     })
            //     // }
            //     onSearchChange={this.handleSearchChange}
            //     results={results}
            //     value={value}
            //     //resultRenderer={resultRenderer}
            //     noResultsMessage="Kein Projekt gefunden."
            //     showNoResults={false}
            //     size="mini"
            // />
        );
    };

    handleSearchChange(event: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData): void {
        const {auftragsverwaltung} = this.props;

        auftragsverwaltung.ContractorStore.searchTerm = data.value;

        this.setState({
            value: data.value
        });
    };

}
